import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const BOOBuildOwnOperateProjects: React.FC = () => {
  return (
    <>
      <PageHeader title="BOO (Build-Own-Operate) Projects" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/commercial-1.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/commercial-2.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">BOO (Build-Own-Operate) Projects</h1>
              
              <h3 className="mb-4">Delivering Long-Term Water Solutions Through Ownership-Based Models</h3>
              <p>At WTIL, we offer Build-Own-Operate (BOO) models for industrial and municipal clients looking for a long-term, hassle-free approach to water and wastewater treatment. With this model, we invest in and operate the plant on behalf of the client, delivering treated water as a service. This eliminates the capital burden on the client while ensuring high-quality performance and uptime.</p>
              <p>With successful BOO references across power, cement, textiles, and chemical industries, we have demonstrated our ability to deliver end-to-end, reliable utility water systems under performance-linked contracts.</p>

              <h3 className="mb-4">Our BOO Scope Covers:</h3>
              
              <div className="mb-4">
                <h5><i className="fa fa-water text-primary me-2"></i>Raw Water and Pre-treatment Systems</h5>
                <p className="ms-4">Fully integrated water intake and filtration systems managed under a performance model.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-cog text-primary me-2"></i>RO/UF/EDI/Demineralization Systems</h5>
                <p className="ms-4">High-quality process water delivered on-demand without operational overheads.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-recycle text-primary me-2"></i>ZLD & Wastewater Recycling Plants</h5>
                <p className="ms-4">Complete ownership and responsibility of treated effluent, sludge handling, and reuse.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-building text-primary me-2"></i>Sewage Treatment for Reuse</h5>
                <p className="ms-4">Compact, energy-efficient plants for township, housing, or industrial colony reuse systems.</p>
              </div>

              <h3 className="mb-4">Why Choose WTIL's BOO Model?</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i><strong>Zero Capex for the Client</strong> – WTIL invests in the infrastructure, so you don't have to.</p>
              <p><i className="fa fa-check-circle text-success me-2"></i><strong>Guaranteed Output Quality</strong> – Performance-linked contracts ensure water quality and volume.</p>
              <p><i className="fa fa-check-circle text-success me-2"></i><strong>End-to-End Operations</strong> – WTIL handles installation, operations, chemicals, and manpower.</p>
              <p><i className="fa fa-check-circle text-success me-2"></i><strong>Scalable & Modular</strong> – Plants designed for flexibility, with future expansion in mind.</p>
              <p><i className="fa fa-check-circle text-success me-2"></i><strong>O&M & Compliance Responsibility</strong> – WTIL ensures environmental and regulatory compliance.</p>

              <h3 className="mb-4">Industries We Serve with BOO:</h3>
              <p><i className="fa fa-industry text-primary me-2"></i>Cement</p>
              <p><i className="fa fa-bolt text-primary me-2"></i>Power Plants & Captive Utilities</p>
              <p><i className="fa fa-cube text-primary me-2"></i>Steel, Mining & Metallurgy</p>
              <p><i className="fa fa-pills text-primary me-2"></i>Pharmaceuticals & Chemicals</p>
              <p><i className="fa fa-building text-primary me-2"></i>Small Industries</p>

              <h3 className="mb-4">Success Story Snapshot</h3>
              <div className="bg-light p-4 mb-4">
                <h5 className="text-primary mb-3">20 m³/hr BOO RO Plant for Cement Construction Project – Nagaur, Rajasthan</h5>
                <p>Delivered under a performance-based, per-KL billing model. Enabled significant capex savings for the client while ensuring continuous high-quality RO water during their critical construction phase.</p>
              </div>

              <h3 className="mb-4">Want a BOO Model for Your Facility?</h3>
              <p className="mb-4">Connect with our local representative to explore a customized solution –</p>
              <div className="text-center">
                <a href="/contact" className="btn btn-primary btn-lg px-5 py-3">
                  <i className="fa fa-phone me-2"></i>Click here to reach us
                </a>
              </div>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default BOOBuildOwnOperateProjects;
